module.exports = __webpack_public_path__ + "static/media/fa-regular-400.1ef86349.svg";